import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Button,
  Modal,
  Form,
  Col,
  Table,
  Spin,
  Select,
  Divider,
  Tag,
} from "antd";

import { CheckCircleOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { rightAction } from "../../../redux/actions";
import { apiConfig, labelConfig, staticConfig } from "../configurations.config";

const { Text, Title } = Typography;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Description",
    dataIndex: "description",
    sorter: (a, b) => a["description"].localeCompare(b["description"]),
  },
  {
    title: "Is Cash Payment?",
    dataIndex: "cashPayment",
    sorter: (a, b) => a["cashPayment"].localeCompare(b["cashPayment"]),
  },
  {
    title: "Position	",
    dataIndex: "position",
    sorter: (a, b) => a["position"].localeCompare(b["position"]),
  },
];

const ManagePaymentType = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [paymentTypeList, setPaymentTypeList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    getPaymentTypeList();
    BOM.HasPermission("CREATE_PAYMENTTYPE") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getPaymentTypeList = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Paymenttypes, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempPaymentTypeList = [];

        objList.forEach((element) => {
          tempPaymentTypeList.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            description: element?.description ? element?.description : "-",
            cashPayment: element?.isCashPayment ? "Yes" : "No",
            position:
              element?.position || element.position === 0
                ? element?.position
                : "-",
          });
        });

        setPaymentTypeList(tempPaymentTypeList);
        setOriginalList(tempPaymentTypeList);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.Paymenttypes, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempPaymentTypeList = [];

          objList.forEach((element) => {
            tempPaymentTypeList.push({
              key: element?.id,
              id: element?.id,
              name: element?.name ? element?.name : "-",
              description: element?.description ? element?.description : "-",
              cashPayment: element?.isCashPayment ? "Yes" : "No",
              position:
                element?.position || element.position === 0
                  ? element?.position
                  : "-",
            });
          });

          resolve(tempPaymentTypeList);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    BOM.HasPermission("UPDATE_PAYMENTTYPE") &&
      [
        (cnt.RIGHT_EDIT_BTN,
        BOM.HasPermission("DELETE_PAYMENTTYPE") && cnt.RIGHT_DELETE_BTN),
      ].map((item) => {
        dispatch({
          type: item,
        });
      });
  };
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setPaymentTypeList(originalList);
      return;
    }
    const filterBySearch = originalList.filter((item) =>
      item?.name?.toLowerCase().includes(searchKey?.toLowerCase())
    );
    setPaymentTypeList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  //   function handleOnView() {
  //     const { detailBtn } = rightBtn;
  //     if (detailBtn.toLowerCase() === "primary") {
  //       navigate("/view-employee", { state: { id: selectedRow.id } });
  //     } else {
  //       console.log("Could not open the link");
  //     }
  //   }
  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-payment-type", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }
  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-payment-type", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }
  const handleOnDelete = () => {
    let action = "Delete  ";
    let name = `${selectedRow.name}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + name,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Paymenttypes}/${selectedRow.key}`;
        let body = {
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deletePaymentTypeMsg);
            navigate("/manage-payment-type");
            getPaymentTypeList();
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      //   onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      onDelete={handleOnDelete}
    >
      <TopContent
        pageTitle={labelConfig.managePaymentType}
        pageItems={staticConfig.managePaymentTypeItems}
      />

      <Card
        title={`${labelConfig.paymentType} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name"
                style={{
                  width: 400,
                }}
                allowClear
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={paymentTypeList}
              columns={columns}
              fileName={"Payment Type List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={paymentTypeList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManagePaymentType);
